<template>
    <el-dialog
            :title="titleName"
            :visible.sync="dialogFormVisible"
            width="36%"
    >
        <el-form :model="form" :rules="rules" ref="ruleForm">
            <el-input v-model="form.id" autocomplete="off" style="display: none;"></el-input>
            <el-form-item label="编码" :label-width="formLabelWidth" :required="true" prop="fco">
                <el-input v-model="form.fco" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="名称" :label-width="formLabelWidth" :required="true" prop="fna">
                <el-input v-model="form.fna" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth" :required="true" prop="sta">
                <el-radio-group v-model="form.sta">
                    <el-radio label="0">正常</el-radio>
                    <el-radio label="1">停用</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="dialogFormVisible = false">取 消</el-button>
            <el-button size="mini" type="primary" @click="addAndUpdate('ruleForm')">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        data() {
            return {
                dialogFormVisible: true,
                url: '',
                titleName: '',
                form: {
                    id: '',
                    zhangTaoId: null,
                    fco: '',
                    fna: '',
                    fty: '',
                    sta: ''
                },
                rules: {
                    id: [{required: true, message: '请输入主键', trigger: 'blur'}],
                    zhangTaoId: [{required: true, message: '请输入账套ID', trigger: 'blur'}],
                    fco: [{required: true, message: '请输入编码', trigger: 'blur'}],
                    fna: [{required: true, message: '请输入名称', trigger: 'blur'}],
                    sta: [{required: true, message: '请输入状态', trigger: 'blur'}]
                },
                formLabelWidth: '56px'
            };
        },
        methods: {
            int(id) {

                this.$refs['ruleForm'].resetFields();
                this.dialogFormVisible = true;
                this.form.id = '';
                this.form.zhangTaoId = null;
                this.form.fco = '';
                this.form.fna = '';
                this.form.fty = '';
                this.form.sta = '0';

                if (id == 'add') {
                    this.titleName = "辅助账类型-新增";
                    this.url = "/business/fuZhuType/save";
                } else {
                    this.titleName = "辅助账类型-修改";
                    this.url = "/business/fuZhuType/update";
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/fuZhuType/view'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(r => {
                        this.form = r.data.data;
                    }).finally(r => {
                    })
                }
            },
            addAndUpdate(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$httpTAG({
                            url: this.$httpTAG.adornUrl(this.url),
                            method: 'post',
                            data: this.$httpTAG.adornData({
                                ...this.form
                            })
                        }).then(res => {
                            if (res.data.code == 0) {
                                this.$notify({
                                    title: '操作成功！',
                                    type: 'success',
                                    offset: 600
                                });
                                this.dialogFormVisible = false
                                this.$emit("handleCurrentChange", 1);
                            } else {
                                this.$message({ // 失败
                                    type: 'fail',
                                    message: res.data.msg
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
</style>
